import {
  EDeliveryStatus,
  EInProcessCheckStatus,
  ELoadingOrderStatus,
  EPackagingType,
  EPackType,
  EPalletType,
  EPrepareStatus,
  EProcessStatus,
  EProductionPlanType,
  EProductType,
  EReceiveStatus,
} from "model";
import { EAuditTrailAction } from "model/Type/EAuditTrailAction";
import { ECCPLocationStatus } from "model/Type/ECCPLocationStatus";
import { ECountType } from "model/Type/ECountType";
import { EMaterialRequirement } from "model/Type/EMaterialRequirement";
import { translations } from "utils/i18n";

export const PACKAGING_TYPE = [
  {
    type: EPackagingType.CARTON,
    name: translations.type.carton,
  },
  {
    type: EPackagingType.SHOVE,
    name: translations.type.shove,
  },
  {
    type: EPackagingType.BAG,
    name: translations.type.bag,
  },
  {
    type: EPackagingType.CAN,
    name: translations.type.can,
  },
];
export const PALLET_TYPE = [
  {
    type: EPalletType.ALL,
    name: translations.type.allType,
  },
  {
    type: EPalletType.WOOD,
    name: translations.type.wood,
  },
  {
    type: EPalletType.FLAT_PLASTIC,
    name: translations.type.flatPlastic,
  },
  {
    type: EPalletType.HOLE_PLASTIC,
    name: translations.type.holePlastic,
  },
  {
    type: EPalletType.ALUMINUM,
    name: translations.type.aluminum,
  },
  {
    type: EPalletType.TEMPORARY,
    name: translations.type.temporary,
  },
  {
    type: EPalletType.CONTAINER_PLASTIC,
    name: translations.type.containerPlastic,
  },
];

export const PACK_TYPE = [
  {
    type: EPackType.HU,
    name: translations.type.jar,
  },
  {
    type: EPackType.HOP,
    name: translations.type.box,
  },
  {
    type: EPackType.KG,
    name: translations.type.kg,
  },
  {
    type: EPackType.CAN,
    name: translations.type.can,
  },
  {
    type: EPackType.CHAI,
    name: translations.type.bottle,
  },
  {
    type: EPackType.GOI,
    name: translations.type.package,
  },
  {
    type: EPackType.PCE,
    name: translations.type.pce,
  },
  {
    type: EPackType.BAO,
    name: translations.type.bag,
  },
  {
    type: EPackType.XO,
    name: translations.type.shove,
  },
  {
    type: EPackType.LT,
    name: translations.type.liter,
  },
];

export const PRODUCT_TYPE = [
  {
    type: EProductType.ALL,
    name: translations.type.allType,
  },
  {
    type: EProductType.MATERIAL,
    name: translations.type.material,
  },
  {
    type: EProductType.FINISH_PRODUCT,
    name: translations.type.finishedProduct,
  },
  {
    type: EProductType.PACKAGING,
    name: translations.type.packaging,
  },
  {
    type: EProductType.SALE_OFF,
    name: translations.type.saleOff,
  },
];

export const STATUS = [
  {
    type: EProcessStatus.NEW,
    name: translations.statusType.new,
  },
  {
    type: EProcessStatus.SPLITTING,
    name: translations.statusType.splitting,
  },
  {
    type: EProcessStatus.SPLIT,
    name: translations.statusType.split,
  },
  {
    type: EProcessStatus.PREPARING,
    name: translations.statusType.preparing,
  },
  {
    type: EProcessStatus.PREPARED,
    name: translations.statusType.prepared,
  },
  {
    type: EProcessStatus.WAIT_FOR_FORKLIFT,
    name: translations.statusType.waitForForklift,
  },
  {
    type: EProcessStatus.HOLDING,
    name: translations.statusType.waitForForklift,
  },
  {
    type: EProcessStatus.WAIT_FOR_RECEIVE,
    name: translations.statusType.waitForReceive,
  },
  {
    type: EProcessStatus.RECEIVED,
    name: translations.statusType.received,
  },
  {
    type: EProcessStatus.RETURN,
    name: translations.statusType.return,
  },
];

export const RECEIVE_DOCUMENT_STATUS = [
  {
    type: EReceiveStatus.NEW,
    name: translations.statusType.new,
  },
  {
    type: EReceiveStatus.IN_PROGRESS,
    name: translations.statusType.inProgress,
  },
  {
    type: EReceiveStatus.COMPLETE,
    name: translations.statusType.completed,
  },
];

export const LOADING_ORDER_STATUS = [
  {
    type: ELoadingOrderStatus.NEW,
    name: translations.statusType.new,
  },
  {
    type: ELoadingOrderStatus.IN_PROGRESS,
    name: translations.statusType.inProgress,
  },
  {
    type: ELoadingOrderStatus.COMPLETE,
    name: translations.statusType.completed,
  },
  {
    type: ELoadingOrderStatus.DELETE,
    name: translations.statusType.deleted,
  },
];
export const PREPARE_DOCUMENT_STATUS = [
  {
    type: EPrepareStatus.NEW,
    name: translations.statusType.new,
  },
  {
    type: EPrepareStatus.IN_PROGRESS,
    name: translations.statusType.inProgress,
  },

  {
    type: EPrepareStatus.COMPLETE,
    name: translations.statusType.completed,
  },
];

export const DELIVERY_TICKET_STATUS = [
  {
    type: EDeliveryStatus.NEW,
    name: translations.statusType.new,
  },
  {
    type: EDeliveryStatus.IN_PROGRESS,
    name: translations.statusType.inProgress,
  },

  {
    type: EDeliveryStatus.COMPLETE,
    name: translations.statusType.completed,
  },
];
export const MATERIAL_REQUIREMENT_STATUS = [
  {
    type: EMaterialRequirement.NEW,
    name: translations.statusType.new,
  },
  {
    type: EMaterialRequirement.BOOKING,
    name: translations.statusType.booking,
  },
  {
    type: EMaterialRequirement.BOOKED,
    name: translations.statusType.booked,
  },
  {
    type: EMaterialRequirement.PREPARED,
    name: translations.statusType.prepared,
  },
  {
    type: EMaterialRequirement.DELIVERED,
    name: translations.statusType.delivered,
  },
];

export const PRODUCTION_PLAN_STATUS = [
  {
    type: EProductionPlanType.NEW,
    name: translations.statusType.new,
  },
  {
    type: EProductionPlanType.HOLD,
    name: translations.statusType.hold,
  },
  {
    type: EProductionPlanType.IN_PROGRESS,
    name: translations.statusType.packaging,
  },
  {
    type: EProductionPlanType.PACKAGED,
    name: translations.statusType.packaged,
  },
  {
    type: EProductionPlanType.DESTROYING,
    name: translations.statusType.destroying,
  },
  {
    type: EProductionPlanType.COMPLETED,
    name: translations.statusType.completed,
  },
];

export const COUNT_TYPE = [
  {
    type: ECountType.LOCATION,
    name: translations.type.location,
  },
  {
    type: ECountType.PRODUCT,
    name: translations.type.product,
  },
];

export const CCP_LOCATION_STATUS = [
  {
    type: ECCPLocationStatus.NEW,
    name: translations.statusType.needCheck,
  },
  {
    type: ECCPLocationStatus.CHECKED,
    name: translations.statusType.checked,
  },
];

// export const UNIT_OF_MEASURE_TYPE = [
//   {
//     type: EProductionPlanType.NEW,
//     name: translations.statusType.new,
//   },
//   {
//     type: EProductionPlanType.HOLD,
//     name: translations.statusType.hold,
//   },
//   {
//     type: EProductionPlanType.IN_PROGRESS,
//     name: translations.statusType.packaging,
//   },
//   {
//     type: EProductionPlanType.PACKAGED,
//     name: translations.statusType.packaged,
//   },
//   {
//     type: EProductionPlanType.DESTROYING,
//     name: "Đang huỷ bì dư",
//   },
//   {
//     type: EProductionPlanType.COMPLETED,
//     name: "Đã hoàn tất",
//   },
// ];

export const AUDIT_TRAIL_ACTION = [
  {
    type: EAuditTrailAction.LOGIN,
    name: translations.type.login,
  },
  {
    type: EAuditTrailAction.INSERT,
    name: translations.type.insert,
  },
  {
    type: EAuditTrailAction.UPDATE,
    name: translations.type.update,
  },
  {
    type: EAuditTrailAction.DELETE,
    name: translations.type.delete,
  },
  {
    type: EAuditTrailAction.CONFIG,
    name: translations.type.config,
  },
  {
    type: EAuditTrailAction.PRINT,
    name: translations.type.print,
  },
  {
    type: EAuditTrailAction.SCAN_EMPLOYEE,
    name: translations.type.scanEmployee,
  },
  {
    type: EAuditTrailAction.SCAN_PRODUCT_LOT,
    name: translations.type.scanProductLot,
  },
  {
    type: EAuditTrailAction.SCAN_CUSTOMER,
    name: translations.type.scanCustomer,
  },
  {
    type: EAuditTrailAction.SCAN_PALLET,
    name: translations.type.scanPallet,
  },
  {
    type: EAuditTrailAction.SCAN_CARTON,
    name: translations.type.scanCarton,
  },
  {
    type: EAuditTrailAction.SCAN_PRODUCT,
    name: translations.type.scanProduct,
  },
  {
    type: EAuditTrailAction.SCAN_END,
    name: translations.type.scanEnd,
  },
  {
    type: EAuditTrailAction.SCAN_DESTROY_LABEL,
    name: translations.type.scanDestroyLabel,
  },
  {
    type: EAuditTrailAction.SCAN_DESTROY_LABEL_END,
    name: translations.type.scanDestroyLabel,
  },
  {
    type: EAuditTrailAction.SCAN_DESTROY_LABEL_FORCE_END,
    name: translations.type.scanDestroyLabel,
  },
  {
    type: EAuditTrailAction.SCAN_TAKE_SAMPLE,
    name: translations.type.scanDestroyLabel,
  },
  {
    type: EAuditTrailAction.SCAN_TAKE_SAMPLE_END,
    name: translations.type.scanDestroyLabel,
  },
  {
    type: EAuditTrailAction.SCAN_BARCODE_INVALID,
    name: translations.type.scanBarcodeValid,
  },
  {
    type: EAuditTrailAction.SCAN_EXPORT_NOTE,
    name: translations.type.scanExportNote,
  },
  {
    type: EAuditTrailAction.SCAN_SPLIT_NOTE,
    name: translations.type.scanSplitNote,
  },
  {
    type: EAuditTrailAction.SCAN_PREPARE_NOTE,
    name: translations.type.scanPrepareNote,
  },
  {
    type: EAuditTrailAction.SCAN_DELIVERY_NOTE,
    name: translations.type.scanDeliveryNote,
  },
  {
    type: EAuditTrailAction.SCAN_DRIVER_SIGN,
    name: translations.type.scanDriverSign,
  },
  {
    type: EAuditTrailAction.PRINT_CARTON_LABEL,
    name: translations.type.printCartonLabel,
  },
  {
    type: EAuditTrailAction.EXPORT_CARTON_BARCODE,
    name: translations.type.exportCartonBarcode,
  },
  {
    type: EAuditTrailAction.EXPORT_PRODUCT_BARCODE,
    name: translations.type.exportProductBarcode,
  },
  {
    type: EAuditTrailAction.GENERATE_CARTON_BARCODE,
    name: translations.type.generateCartonBarcode,
  },
  {
    type: EAuditTrailAction.GENERATE_PRODUCT_BARCODE,
    name: translations.type.generateProductBarcode,
  },
  {
    type: EAuditTrailAction.AUTO_RECEIVE_PRODUCT,
    name: translations.type.autoReceiveProduct,
  },
];

export const INPROCESS_STATUS: {
  title: string;
  value: EInProcessCheckStatus;
}[] = [
  {
    title: translations.inProcessCheckReportDetail.newStatus,
    value: EInProcessCheckStatus.New,
  },
  {
    title: translations.inProcessCheckReportDetail.inProcessStatus,
    value: EInProcessCheckStatus.InProcess,
  },
  {
    title: translations.inProcessCheckReportDetail.reviewedStatus,
    value: EInProcessCheckStatus.Reviewed,
  },
];

export const INPROCESS_EVENTS = {
  INIT_PORT: "INIT_PORT",
  PERFORM_ADDED: "PERFORM_ADDED",
  CANCEL_NOTIFICATION: "CANCEL_NOTIFICATION",
  CLEAR_NOTIFICATION: "CLEAR_NOTIFICATION",
  PAUSE_REMINDER: "PAUSE_REMINDER",
  RESUME_REMINDER: "RESUME_REMINDER"
};
